import { LogEnvListResponse, LogEnvDetailResponse } from '../types/env-log.types';

import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const fetchEnvLogList = async (params: string = ''): Promise<LogEnvListResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.envCollectionLogList(params)}`;
    return await request.get(url);
}

export const fetchEnvLogDetail = async (request_id: string): Promise<LogEnvDetailResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.envCollectionLogDetail(request_id)}`;
    return await request.get(url);
}